import { GetDamagedCustomerAttachedDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerAttachedDocumentImages/getDamagedCustomerAttachedDocumentImagesQuery.type';
import { getDamagedCustomerAttachedDocumentImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerAttachedDocumentImages/getDamagedCustomerAttachedDocumentImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedCustomerAttachedDocumentImagesQueryOptions = (
  params: GetDamagedCustomerAttachedDocumentImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['DamagedCustomerAttachedDocumentImages', params],
    queryFn: () => getDamagedCustomerAttachedDocumentImagesFunction(params),
    enabled: true,
  });
};
